/* istanbul ignore file */

export const getLocHref = () => {
    return document?.location?.href || '';
};
